/**
 * The World agent's name (RFC 0336): its session's title, which the person
 * can change. One name everywhere it shows: the World view's header, its row
 * in the launcher, a call with it.
 */

import type { AnyDocumentId, Repo } from '@automerge/automerge-repo/slim'

/** What it is called until the person names it. The daemon writes the same
 *  title when it makes the session (core `ensureWorldAgentSession`). */
export const WORLD_AGENT_DEFAULT_NAME = 'Mod'

/** The title sessions were made with before it had a name: read as unnamed. */
const UNNAMED = 'World agent'

export function worldAgentName(sessionDoc: unknown): string {
  const title = (sessionDoc as { title?: unknown } | undefined)?.title
  const name = title == null ? '' : String(title).trim()
  return name && name !== UNNAMED ? name : WORLD_AGENT_DEFAULT_NAME
}

/** Name it. The session is in no project, so its own title is the only
 *  place the name lives. */
export async function renameWorldAgent(
  repo: Repo,
  sessionId: string,
  name: string,
): Promise<void> {
  const next = name.trim()
  if (!next) return
  const handle = await repo.find(sessionId as AnyDocumentId)
  handle.change((d) => {
    const doc = d as { title?: string; updatedAt?: number }
    doc.title = next
    doc.updatedAt = Date.now()
  })
}
